import { Navigate, Route, Routes } from 'react-router-dom';

import { ErrorBoundary } from './components/ErrorBoundary';
import MainLayout from './components/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import RoleRoute from './components/RoleRoute';
import Analytics from './pages/Analytics';
import Devices from './pages/Devices';
import Firmwares from './pages/Firmwares';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Users from './pages/Users';

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/devices" replace />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/devices" element={<Devices />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/profile" element={<Profile />} />
            <Route element={<RoleRoute allowedRoles={['admin']} />}>
              <Route path="/users" element={<Users />} />
              <Route path="/firmwares" element={<Firmwares />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
